import { formatString } from '@websrc/App/Helpers/formatting'
import { styles } from 'leds'
import React from 'react'

import { Button } from './Button/Button'

export type LoadMoreResultsProps = {
  children: string
  loadMoreFn: () => void
  totalHits: number
  numberHits: number
  resultsInfoStaticText?: string
  onClick?: () => void
  isLoading?: boolean
}

export const LoadMoreResults = ({
  children,
  loadMoreFn,
  resultsInfoStaticText,
  totalHits,
  numberHits,
  onClick,
  isLoading,
}: LoadMoreResultsProps) => (
  <div
    className={styles({
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      marginY: 40,
    })}
  >
    {Boolean(totalHits > numberHits) && (
      <Button
        color={'black'}
        colorMode={'light'}
        dataTestid={'load-more-button'}
        isLoading={isLoading}
        onClick={() => {
          loadMoreFn()
          onClick?.()
        }}
        size={'medium'}
        text={children}
        type={'secondary'}
      />
    )}
    <span className={styles({ marginTop: 10 })}>
      {formatString(resultsInfoStaticText, numberHits, totalHits)}
    </span>
  </div>
)
